const coins = require('../coins');
const REFERENCE_ASSETS = require('../reference-assets.js');

module.exports = [{
    dataIndex: 0,
    id: 'factory-v2-0',
    name: 'factory-v2-0',
    lpTokenInfo: {
        name: '3poolCurve',
        symbol: '3poolCrv',
    },
    assets: 'DAI+USDC+USDT',
    coins: [
        coins.dai,
        coins.usdc,
        coins.usdt,
    ],
    addresses: {
        swap: '0x7A0e3b70b1dB0D6CA63Cac240895b2D21444A7b9',
        lpToken: '0x7A0e3b70b1dB0D6CA63Cac240895b2D21444A7b9',
        gauge: '0x7A0e3b70b1dB0D6CA63Cac240895b2D21444A7b9',
    },
    hasNoGauge: true,
    isFactoryOnlyPool: true,
    factoryVersion: 2,
    // gaugeVersion: 3, // No CRV rewards
    hasNoCRVRewards: true,
}];
